import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import { useLocation } from 'react-router-dom';

import { getLocalStorage } from '@shared/constants';

export const PostHogIdentify = () => {
    const posthog = usePostHog();
    const location = useLocation();

    useEffect(() => {
        const email = getLocalStorage('userEmail');
        const companyId = getLocalStorage('companyId');
        const companyName = getLocalStorage('companyName');

        const distinctId = posthog.get_distinct_id();

        if (email && distinctId !== email) {
            posthog.identify(email, {
                email,
                company_id: companyId,
                company_name: companyName,
            });
        }
    }, [location.pathname, posthog?.__loaded]);

    return null;
};